import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../popup/modal-layout";
import XCloseIcon from "../../icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../context/Context";
import { useApiCall } from "../../custom-hooks/api-call";
import Tooltip from "../../ui/tooltip";
import { Loader2, Trash2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../form/form-layout";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const EditDealModal = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  dealData = null,
  type,
  DealStages = [],
  ClientList = [],
  page = 1,
  onLoadMoreClients,
  hasMoreClients,
  isLoadingClients,
  contactId,
  onDealUpdated,
  Style,
}) => {
  console.log(dealData);
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const isWon = dealData?.current_stage?.dealstatus === "Won";
  const isLost = dealData?.current_stage?.dealstatus === "Lost";
  const activeColor = isWon ? "#22c55e" : isLost ? "#ef4444" : "#2563eb";
  const metas = Object.fromEntries(
    dealData?.metas?.map((m) => [m.meta_key, m.meta_value]) ?? []
  );
  const [searchClient, setSearchClient] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [CurrentStage, setCurrentStage] = useState(null);
  const [mainProducts, setMainProducts] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);
  const [loadingPackages, setLoadingPackages] = useState(false);
  const initialMainId = metas?.main_product ? Number(metas.main_product) : null;
  const initialSubId = dealData?.deal_product
    ? Number(dealData.deal_product)
    : null;
  const initialPackageId = dealData?.deal_package
    ? Number(metas.deal_package)
    : null;
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    if (!dealData?.contactid) return;

    const fetchProjects = async () => {
      try {
        const res = await apiCall({
          method: "get",
          url: `projects/get-client-projects-list/${dealData.contactid}`,
        });
        setProjectList(res?.data || []);
      } catch (error) {
        console.error("Error fetching client projects:", error);
      }
    };

    fetchProjects();
  }, [dealData?.contactid]);

  // console.log("dealData", dealData)

  useEffect(() => {
    if (dealData?.metas?.length) {
      const isAddonMeta = dealData.metas.find((m) => m.meta_key === "is_addon");
      const projectMeta = dealData.metas.find(
        (m) => m.meta_key === "projectid"
      );

      formik.setFieldValue("attachProject", isAddonMeta?.meta_value === "1");
      formik.setFieldValue(
        "projectId",
        projectMeta?.meta_value ? Number(projectMeta.meta_value) : ""
      );
    }
  }, [dealData?.metas]);

  useEffect(() => {
    if (dealData?.current_stage && DealStages?.length > 0) {
      const stage = DealStages.find(
        (s) => s.name === dealData.current_stage?.dealstatus ?? "-"
      );
      setCurrentStage(stage?.id || DealStages[0]?.id);
    } else {
      setCurrentStage(DealStages[0]?.id || null); // fallback
    }
  }, [dealData, DealStages]);

  useEffect(() => {
    loadMainProducts();
  }, []);

  useEffect(() => {
    if (initialMainId) {
      loadSubProducts(initialMainId).then(() => {
        if (initialSubId) {
          loadPackages(initialSubId);
        }
      });
    } else if (initialSubId) {
      loadPackages(initialSubId);
    }
  }, [initialMainId, initialSubId]);

  const validationSchema = yup.object({
    name: yup.string().required("This Field is Required"),
    main_product: yup.number().required("This Field is Required"),
    deal_product: yup.number().required("This Field is Required"),
    deal_package_id: yup.number().required("This Field is Required"),
    estimated_payment_date: yup.string().required("This Field is Required"),
    dealamount: yup.number().required("This Field is Required"),
    dealprobability: yup.number().required("This Field is Required"),
    description: yup.string().required("This Field is Required"),

    // new conditional validation
    projectId: yup.string().when("attachProject", {
      is: true,
      then: (schema) => schema.required("Please select a project"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const [extraMeta, setExtraMeta] = useState(
    dealData?.metas
      ? dealData.metas
          .filter(
            (m) =>
              ![
                "features",
                "deal_product",
                "contactid",
                "dealstage",
                "deal_package",
                "estimated_payment_date",
                "dealamount",
                "dealprobability",
                "description",
                "dealpackage",
                "dealkey",
                "packageCat",
                "packagename",
                "name",
                "group_id",
                "dealtype",
                "main_product",
              ].includes(m.meta_key)
          )
          .map((m) => ({ key: m.meta_key, value: m.meta_value }))
      : []
  );

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      contactid: contactId ?? dealData?.contactid ?? "",

      main_product: initialMainId || "",

      deal_product: dealData?.deal_product ? Number(dealData.deal_product) : "",

      deal_package_id: dealData?.deal_package
        ? Number(dealData.deal_package)
        : "",
      deal_package: dealData?.metas?.packagename || "",
      features: metas?.features || "",
      estimated_payment_date: metas?.estimated_payment_date || "",
      dealamount: metas?.dealamount || "",
      dealstage: dealData?.dealstage || DealStages[0]?.name || "",
      dealprobability: metas?.dealprobability || "",
      description: metas?.description || "",
      name: dealData?.name || "",
      attachProject: false, // new
      projectId: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const combinedExtraMeta = [
        { key: "features", value: values.features },
        { key: "main_product", value: String(values.main_product) }, // save as string like other metas
        ...extraMeta.filter((f) => f.key && f.value),
        { key: "is_addon", value: values.attachProject ? "1" : "0" },
        { key: "projectid", value: values.projectId || "" },
      ];

      const data = {
        contactid: values.contactid,
        name: values.name,
        deal_product: Number(values.deal_product),
        deal_package: Number(values.deal_package_id) || null,
        estimated_payment_date: values.estimated_payment_date,
        dealamount: values.dealamount,
        dealstage: values.dealstage?.toLowerCase().replace(/\s+/g, "_") || "",
        dealprobability: values.dealprobability,
        description: values.description,
        extra_meta: combinedExtraMeta,
      };

      // console.log("data", data)

      try {
        const url = dealData?.dealid
          ? `deals/update-deal/${dealData?.dealid}`
          : "deals/add-deal";

        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });

        if (onDealUpdated) onDealUpdated();
        if (onSubmit) onSubmit(apiRes?.message || "Deal saved successfully");

        formik.resetForm();
        onClose();
      } catch (error) {
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  useEffect(() => {
    const textarea = document.querySelector("textarea[name='features']");
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [formik.values.features]);

  const loadMainProducts = async () => {
    setLoadingMain(true);
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });
      setMainProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading main products:", err);
    } finally {
      setLoadingMain(false);
    }
  };

  const loadSubProducts = async (mainId) => {
    if (!mainId) {
      setSubProducts([]);
      return;
    }
    setLoadingSub(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${mainId}`,
      });
      setSubProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading sub-products:", err);
      setSubProducts([]);
    } finally {
      setLoadingSub(false);
    }
  };

  const loadPackages = async (subProductId) => {
    if (!subProductId) {
      setPackages([]);
      return;
    }
    setLoadingPackages(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-product-packages/${subProductId}`,
      });
      setPackages(res?.data || []);
    } catch (err) {
      console.warn("Error loading packages:", err);
      setPackages([]);
    } finally {
      setLoadingPackages(false);
    }
  };

  // Handlers for selects
  const handleMainSelect = async (option) => {
    const id = option?.value || "";

    formik.setFieldValue("main_product", id);

    formik.setFieldValue("deal_product", "");
    formik.setFieldValue("deal_package_id", "");
    formik.setFieldValue("deal_package", "");
    setSubProducts([]);
    setPackages([]);

    if (id) {
      await loadSubProducts(id);
    }
  };

  const handleSubSelect = async (option) => {
    const id = option?.value || "";
    formik.setFieldValue("deal_product", id);

    formik.setFieldValue("deal_package_id", "");
    formik.setFieldValue("deal_package", "");
    setPackages([]);

    if (id) {
      await loadPackages(id);
    }
  };

  const handlePackageSelect = (option) => {
    const id = option?.value || "";
    const pkg = packages.find((p) => Number(p.packageid) === Number(id));
    formik.setFieldValue("deal_package_id", id);
    formik.setFieldValue("deal_package", pkg?.packagename || "");
    // set features from package if exists
    if (pkg?.features) {
      formik.setFieldValue("features", stripHtml(pkg.features || ""));
    } else {
      // 👇 clear the textbox if "Add Other" or no features exist
      formik.setFieldValue("features", "");
    }
  };

  const handleStageClick = (stageId) => {
    setCurrentStage(stageId);
    const stage = DealStages.find((s) => s.id === stageId);
    const formattedName = stage?.name?.toLowerCase().replace(/\s+/g, "_") || "";
    formik.setFieldValue("dealstage", formattedName);
  };

  const subProductsUnique = subProducts.filter(
    (v, i, a) =>
      a.findIndex(
        (t) =>
          Number(t.id ?? t.subproductid ?? t.productid) ===
          Number(v.id ?? v.subproductid ?? v.productid)
      ) === i
  );
  const packagesUnique = packages.filter(
    (v, i, a) =>
      a.findIndex((t) => Number(t.packageid) === Number(v.packageid)) === i
  );

  const mainOptions = mainProducts.map((mp) => ({
    value: mp.id ?? mp.productid ?? mp.main_product_id ?? mp.id,
    label: mp.products || mp.name || mp.title || `#${mp.id}`,
  }));
  const subOptions = subProductsUnique.map((sp) => ({
    value: sp.id ?? sp.subproductid ?? sp.productid,
    label: sp.products || sp.name || sp.title || `#${sp.id}`,
  }));
  const packageOptions = packagesUnique.length > 0 ? [
    ...packagesUnique.map((pk) => ({
      value: pk.packageid,
      label: pk.packagename || `#${pk.packageid}`,
    })),
    { value: 3, label: "Add Other" },
  ] : [];

  const editMainId = metas?.main_product ? Number(metas.main_product) : null;
  const editSubId = dealData?.deal_product
    ? Number(dealData.deal_product)
    : null;
  const editPackageId = dealData?.deal_package
    ? Number(dealData.deal_package)
    : null;

  useEffect(() => {
    let mounted = true;
    const runPrefill = async () => {
      try {
        if (editMainId) {
          formik.setFieldValue("main_product", editMainId, false);

          await loadSubProducts(editMainId);
        }

        if (editSubId) {
          const existsInSub = subProducts.some(
            (sp) =>
              Number(sp.id ?? sp.subproductid ?? sp.productid) ===
              Number(editSubId)
          );
          if (!existsInSub) {
            setSubProducts((prev) => {
              const merged = [
                ...prev,
                {
                  id: editSubId,
                  products:
                    dealData?.deal_product_name || `Product #${editSubId}`,
                },
              ];
              // ✅ remove duplicates by id/subproductid/productid
              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) =>
                      Number(t.id ?? t.subproductid ?? t.productid) ===
                      Number(v.id ?? v.subproductid ?? v.productid)
                  ) === i
              );
              return unique;
            });
          }

          formik.setFieldValue("deal_product", editSubId, false);

          await loadPackages(editSubId);

          if (editPackageId) {
            const existsPkg = packages.some(
              (pk) => Number(pk.packageid) === Number(editPackageId)
            );
            if (!existsPkg) {
              setPackages((prev) => {
                const merged = [
                  ...prev,
                  {
                    packageid: editPackageId,
                    packagename: metas?.packagename,
                  },
                ];
                // ✅ remove duplicates by packageid
                const unique = merged.filter(
                  (v, i, a) =>
                    a.findIndex(
                      (t) => Number(t.packageid) === Number(v.packageid)
                    ) === i
                );
                return unique;
              });
            }

            formik.setFieldValue("deal_package_id", editPackageId, false);

            formik.setFieldValue(
              "deal_package",
              dealData?.deal_package || metas?.deal_package_name || "",
              false
            );
          }
        } else if (!editSubId && editPackageId) {
          const existsPkg = packages.some(
            (pk) => Number(pk.packageid) === Number(editPackageId)
          );
          if (!existsPkg) {
            setPackages((prev) => {
              const merged = [
                ...prev,
                {
                  packageid: editPackageId,
                  packagename: metas?.packagename,
                },
              ];
              // ✅ remove duplicates by packageid
              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) => Number(t.packageid) === Number(v.packageid)
                  ) === i
              );
              return unique;
            });
          }
          formik.setFieldValue("deal_package_id", editPackageId, false);
        }
      } catch (err) {}
    };

    if (dealData) {
      runPrefill();
    }

    return () => {
      mounted = false;
    };
  }, [dealData]);

  const selectedMainOption =
    mainOptions.find(
      (o) => Number(o.value) === Number(formik.values.main_product)
    ) || null;
  const selectedSubOption =
    subOptions.find(
      (o) => Number(o.value) === Number(formik.values.deal_product)
    ) || null;
  const selectedPackageOption =
    packageOptions.find(
      (o) => Number(o.value) === Number(formik.values.deal_package_id)
    ) || null;

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* Header */}
        {/* <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>{dealData?.dealid ? "Edit Deal" : "Add Deal"}</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer`}
          >
            <XCloseIcon />
          </div>
        </div> */}

        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>
            {/* clients */}
            {/* <div className="flex gap-5">
              {!dealData?.contactid && (
                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label>Client Name</label>
                  <Select
                    name="contactid"
                    classNamePrefix="react-select"
                    className="text-sm"
                    placeholder="Search customer..."
                    value={
                      ClientList.map((c) => ({
                        value: c.userid,
                        label: c.name || "Unnamed",
                      })).find(
                        (opt) => opt.value === formik.values.contactid
                      ) || null
                    }
                    onChange={(option) => {
                      formik.setFieldValue("contactid", option?.value || "");
                    }}
                    options={ClientList.map((c) => ({
                      value: c.userid,
                      label: c.name || "Unnamed",
                    }))}
                    components={{
                      IndicatorSeparator: () => null,
                      LoadingIndicator: () => (
                        <div className="flex items-center pr-2">
                          <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />
                        </div>
                      ),
                    }}
                    isClearable
                    isLoading={isLoadingClients}
                    onInputChange={(value, action) => {
                      if (action.action === "input-change") {
                        setSearchClient(value);
                        if (searchTimeout) clearTimeout(searchTimeout);

                        if (value.length >= 3) {
                          const timeout = setTimeout(() => {
                            onLoadMoreClients(1, value.trim());
                          }, 400);
                          setSearchTimeout(timeout);
                        } else if (value.length === 0) {
                          const timeout = setTimeout(() => {
                            onLoadMoreClients(1, "");
                          }, 300);
                          setSearchTimeout(timeout);
                        }
                      }
                    }}
                    onMenuOpen={() => {
                      if (ClientList.length === 0 && !isLoadingClients) {
                        onLoadMoreClients(1, "");
                      }
                    }}
                    onMenuClose={() => {
                      if (searchClient.length > 0) {
                        setSearchClient("");
                        onLoadMoreClients(1, "");
                      }
                    }}
                    onMenuScrollToBottom={() => {
                      if (
                        !searchClient &&
                        hasMoreClients &&
                        !isLoadingClients
                      ) {
                        onLoadMoreClients(page + 1, "");
                      }
                    }}
                    menuPortalTarget={document.body}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderColor: state.isFocused ? "#e5e7eb" : "#e5e7eb",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #e5e7eb"
                          : "none",
                        "&:hover": { borderColor: "#e5e7eb" },
                        borderRadius: "0.5rem",
                        minHeight: "40px",
                        fontSize: "0.875rem",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 99999,
                        borderRadius: "0.5rem",
                        padding: "0.25rem 0",
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                      option: (base, { isFocused, isSelected }) => ({
                        ...base,
                        backgroundColor: isSelected
                          ? "#3b82f6"
                          : isFocused
                          ? "#eff6ff"
                          : "white",
                        color: isSelected ? "white" : "#111827",
                        cursor: "pointer",
                        fontSize: "0.875rem",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: "#9ca3af",
                      }),
                    }}
                  />
                </div>
              )}
            </div> */}

            {!dealData?.contactid && (
              <FeildWraper width="100%">
                <FormLabel required>Client Name</FormLabel>
                <Select
                  className="text-sm"
                  classNamePrefix="react-select"
                  value={
                    ClientList?.map((c) => ({
                      value: c.userid,
                      label: c.name || "Unnamed",
                    })).find((opt) => opt.value === formik.values.contactid) ||
                    null
                  }
                  onChange={(option) => {
                    formik.setFieldValue("contactid", option?.value || "");
                  }}
                  options={ClientList.map((c) => ({
                    value: c.userid,
                    label: c.name || "Unnamed",
                  }))}
                  isLoading={isLoadingClients}
                  isClearable
                  placeholder="Search customer..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => (
                      <div className="flex items-center pr-2">
                        <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />
                      </div>
                    ),
                  }}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "35px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                      boxShadow: state.isFocused ? "none" : "none",
                      "&:hover": { borderColor: "#DFDFDF" },
                      fontSize: "13px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      padding: "0 14px",
                      cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "auto",
                      padding: "0 0px 0",
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      height: "auto",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#717680",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    menu: (base) => ({
                      ...base,
                      marginTop: "2px",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: state.isSelected ? "#FFF" : "#1E1E1E",
                      backgroundColor: state.isSelected
                        ? "#3b82f6"
                        : state.isFocused
                        ? "#F3F4F6"
                        : "#FFF",
                      padding: "8px 14px",
                      cursor: "pointer",
                    }),
                    indicatorContainer: (base) => ({ ...base, padding: 0 }),
                    dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                  }}
                />
                {formik.touched.main_product && formik.errors.main_product && (
                  <FeildError>{formik.errors.main_product}</FeildError>
                )}
              </FeildWraper>
            )}

            {/* Main Product */}

            <FeildWraper width="100%">
              <FormLabel required>Main Product</FormLabel>
              <Select
                className="text-sm"
                classNamePrefix="react-select"
                value={selectedMainOption}
                onChange={handleMainSelect}
                options={mainOptions}
                isLoading={loadingMain}
                isClearable
                placeholder="Select main product..."
                menuPortalTarget={document.body}
                menuPosition="fixed"
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") {
                    setSearchClient(value);
                    if (searchTimeout) clearTimeout(searchTimeout);

                    if (value.length >= 3) {
                      const timeout = setTimeout(() => {
                        onLoadMoreClients(1, value.trim());
                      }, 400);
                      setSearchTimeout(timeout);
                    } else if (value.length === 0) {
                      const timeout = setTimeout(() => {
                        onLoadMoreClients(1, "");
                      }, 300);
                      setSearchTimeout(timeout);
                    }
                  }
                }}
                onMenuOpen={() => {
                  if (ClientList.length === 0 && !isLoadingClients) {
                    onLoadMoreClients(1, "");
                  }
                }}
                onMenuClose={() => {
                  if (searchClient.length > 0) {
                    setSearchClient("");
                    onLoadMoreClients(1, "");
                  }
                }}
                onMenuScrollToBottom={() => {
                  if (!searchClient && hasMoreClients && !isLoadingClients) {
                    onLoadMoreClients(page + 1, "");
                  }
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              />
              {formik.touched.main_product && formik.errors.main_product && (
                <FeildError>{formik.errors.main_product}</FeildError>
              )}
            </FeildWraper>

            {/* Sub product */}

            <FeildWraper>
              <FormLabel required>Sub Product</FormLabel>
              <Select
                value={
                  subOptions.find(
                    (option) => option.value === formik.values.deal_product
                  ) || null
                }
                onChange={(selectedOption) => {
                  formik.setFieldValue(
                    "deal_product",
                    selectedOption ? selectedOption.value : ""
                  );
                  handleSubSelect(selectedOption); // if you have custom logic
                }}
                options={subOptions}
                isLoading={loadingSub}
                isClearable
                placeholder="Select sub product..."
                classNamePrefix="react-select"
                className="text-sm"
                menuPortalTarget={document.body}
                noOptionsMessage={() =>
                  formik.values.main_product
                    ? "No sub-products"
                    : "Select main product first"
                }
                menuPosition="fixed"
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              />
              {formik.touched.deal_product && formik.errors.deal_product && (
                <FeildError>{formik.errors.deal_product}</FeildError>
              )}
            </FeildWraper>

            {/* Package */}

            {/* Deal Package */}

            <FeildWraper>
              <FormLabel required>Package</FormLabel>

              <Select
                value={selectedPackageOption}
                onChange={handlePackageSelect}
                options={packageOptions}
                isLoading={loadingPackages}
                isClearable
                placeholder="Select package..."
                classNamePrefix="react-select"
                className="text-sm"
                menuPortalTarget={document.body}
                noOptionsMessage={() =>
                  formik.values.deal_product
                    ? "No packages"
                    : "Select sub product first"
                }
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({
                    ...base,
                    padding: 0,
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    padding: 0,
                  }),
                }}
              />

             

              {formik.touched.deal_package_id && formik.errors.deal_package_id && (
                      <FeildError>{formik.errors.deal_package_id}</FeildError>
                    )}
            </FeildWraper>

            {dealData?.contactid && type === "account" && (
              <>
                {/* <div className="flex flex-col gap-3"> */}
                {/* Checkbox Row */}

                {/* <div className="flex items-center gap-2">
                  <input
                    id="isAddon"
                    type="checkbox"
                    checked={formik.values.attachProject || false}
                    onChange={(e) => {
                      formik.setFieldValue("attachProject", e.target.checked);
                      if (!e.target.checked) {
                        formik.setFieldValue("projectId", "");
                      }
                    }}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label
                    htmlFor="isAddon"
                    className="text-sm font-medium text-gray-700 select-none cursor-pointer"
                  >
                    Is Addon
                  </label>
                </div> */}

                <div className="w-full px-4">
                  <div className="flex flex-start  gap-2">
                    <input
                      id="isAddon"
                      type="checkbox"
                      checked={formik.values.attachProject || false}
                      onChange={(e) => {
                        formik.setFieldValue("attachProject", e.target.checked);
                        if (!e.target.checked) {
                          formik.setFieldValue("projectId", "");
                        }
                      }}
                      className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    />

                    <div>Is Addon</div>
                  </div>
                </div>

                {/* Project Dropdown */}
                {formik.values.attachProject && (
                  <FeildWraper width="100%">
                    <FormLabel>Select Project</FormLabel>

                    <Select
                      name="projectId"
                      classNamePrefix="react-select"
                      className="text-sm"
                      value={
                        projectList
                          ?.map((p) => ({
                            value: p.projectid,
                            label: p.invoiceid,
                          }))
                          .find(
                            (opt) => opt.value === formik.values.projectId
                          ) || null
                      }
                      onChange={(option) =>
                        formik.setFieldValue("projectId", option?.value || "")
                      }
                      options={
                        projectList?.map((p) => ({
                          value: p.projectid,
                          label: p.invoiceid,
                        })) || []
                      }
                      components={{
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => (
                          <div className="flex items-center pr-2">
                            <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />
                          </div>
                        ),
                      }}
                      isClearable
                      placeholder="Select project..."
                      menuPortalTarget={document.body}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "35px",
                          height: "auto",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          backgroundColor: state.isDisabled
                            ? "#f0f0f0"
                            : "#FFF",
                          boxShadow: state.isFocused ? "none" : "none",
                          "&:hover": { borderColor: "#DFDFDF" },
                          fontSize: "13px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          padding: "0 14px",
                          cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "auto",
                          padding: "0 0px 0",
                        }),
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          height: "auto",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#717680",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 99999,
                        }),
                        menu: (base) => ({
                          ...base,
                          marginTop: "2px",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: state.isSelected ? "#FFF" : "#1E1E1E",
                          backgroundColor: state.isSelected
                            ? "#3b82f6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "#FFF",
                          padding: "8px 14px",
                          cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({
                          ...base,
                          padding: 0,
                        }),
                        dropdownIndicator: (base) => ({
                          ...base,
                          padding: 0,
                        }),
                      }}
                    />

                    {formik.touched.projectId && formik.errors.projectId && (
                      <FeildError>{formik.errors.projectId}</FeildError>
                    )}
                  </FeildWraper>
                )}
                {/* </div> */}
              </>
            )}

            {/* Deal name */}
            <FeildWraper>
              <FormLabel required>Deal Name</FormLabel>
              <input
                type="text"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                placeholder="Name"
                disabled={!!dealData?.dealid}
              />
              {formik.touched.name && formik.errors.name && (
                <FeildError>{formik.errors.name}</FeildError>
              )}
            </FeildWraper>

            {/* date */}
            <FeildWraper>
              <FormLabel required>Amount</FormLabel>
              <input
                type="number"
                name="dealamount"
                min="0"
                value={formik.values.dealamount}
                onChange={formik.handleChange}
              />
              {formik.touched.dealamount && formik.errors.dealamount && (
                <FeildError>{formik.errors.dealamount}</FeildError>
              )}
            </FeildWraper>

            {/* amount */}
            <FeildWraper>
              <FormLabel required>Estimated Date</FormLabel>
              <input
                type="date"
                name="estimated_payment_date"
                min={new Date().toISOString().split("T")[0]}
                value={formik.values.estimated_payment_date}
                onChange={formik.handleChange}
              />
              {formik.touched.estimated_payment_date &&
                formik.errors.estimated_payment_date && (
                  <FeildError>
                    {formik.errors.estimated_payment_date}
                  </FeildError>
                )}
            </FeildWraper>

            {/* <div className="w-full max-w-md flex flex-col gap-2">
              <p className="text-gray-700 font-medium mb-2">Pipeline stage</p>
              <div className="flex overflow-hidden h-8">
                {DealStages.map((stage, index) => {
                  const isFirst = index === 0;
                  const isLast = index === DealStages.length - 1;

                  let clipPath = "";
                  if (isFirst)
                    clipPath =
                      "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)";
                  else if (isLast)
                    clipPath =
                      "polygon(0 0, 10px 50%, 0 100%, 100% 100%, 100% 0)";
                  else
                    clipPath =
                      "polygon(0 0, 10px 50%, 0 100%, calc(100% - 10px) 100%, 100% 50%, calc(100% - 10px) 0)";

                  const isActive = CurrentStage >= stage.id;

                  return (
                    <Tooltip
                      key={stage.id}
                      className=""
                      boxClassName=""
                      content={stage.name}
                      position="bottom center"
                    >
                      <div
                        onClick={() => handleStageClick(stage.id)}
                        className={`min-h-[27px] min-w-[45px] flex-1 ${
                          isActive ? "" : "bg-gray-200"
                        } ${
                          isFirst
                            ? "rounded-tl-md rounded-bl-md"
                            : isLast
                            ? "rounded-tr-md rounded-br-md"
                            : ""
                        }`}
                        style={{
                          clipPath,
                          WebkitClipPath: clipPath,
                          backgroundColor: isActive ? activeColor : "#e5e7eb",
                          transition: "background-color 0.3s ease",
                        }}
                      />
                    </Tooltip>
                  );
                })}
              </div>
            </div> */}

            {/* Pipeline stage */}
            <FeildWraper className="!max-w-md">
              <FormLabel>Pipeline stage</FormLabel>
              <div className="flex  overflow-hidden h-8">
                {DealStages.map((stage, index) => {
                  // const isActive = index === CurrentStage;
                  const isFirst = index === 0;
                  const isLast = index === DealStages.length - 1;

                  //  Set clip-path based on position
                  let clipPath = "";
                  if (isFirst) {
                    clipPath = `
                                  polygon(
                                    0 0,
                                    calc(100% - 10px) 0,
                                    100% 50%,
                                    calc(100% - 10px) 100%,
                                    0 100%
                                  )
                                    
                                `;
                  } else if (isLast) {
                    clipPath = `
                                polygon(
                                  0 0,
                                  10px 50%,
                                  0 100%,
                                  100% 100%,
                                  100% 0
                                )
                              `;
                  } else {
                    clipPath = `
                                  polygon(
                                    0 0,
                                    10px 50%,
                                    0 100%,
                                    calc(100% - 10px) 100%,
                                    100% 50%,
                                    calc(100% - 10px) 0
                                  )
                                `;
                  }

                  return (
                    <Tooltip
                      key={`${index}-asideBottomItems`}
                      className={`${Style.Tooltip}`}
                      boxClassName={Style.TooltipBox}
                      content={stage?.name}
                      position={"bottom center"}
                    >
                      <div
                        key={index}
                        onClick={() => {
                          handleStageClick(stage.id);
                        }}
                        className={`
                                        min-h-[27px] min-w-[60px]  flex-1 
                                      ${
                                        stage.id <= CurrentStage
                                          ? "bg-[#2563eb]"
                                          : "bg-gray-200"
                                      }
                                      ${
                                        isFirst
                                          ? `rounded-tl-md rounded-bl-md`
                                          : isLast
                                          ? "rounded-tr-md rounded-br-md"
                                          : null
                                      }
                                    `}
                        style={{
                          clipPath: clipPath,
                          WebkitClipPath: clipPath,
                        }}
                      />
                    </Tooltip>
                  );
                })}
              </div>
            </FeildWraper>

            {/* probability */}
            <FeildWraper>
              <FormLabel required>Deal Probability</FormLabel>
              <select
                name="dealprobability"
                value={formik.values.dealprobability}
                onChange={formik.handleChange}
              >
                <option value="">-- Select Probability --</option>
                {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
              {formik.touched.dealprobability &&
                formik.errors.dealprobability && (
                  <FeildError>{formik.errors.dealprobability}</FeildError>
                )}
            </FeildWraper>

            {/* description */}
            <FeildWraper>
              <FormLabel required>Description</FormLabel>
              <input
                type="text"
                name="description"
                value={formik.values.description}
                onChange={formik.handleChange}
              />
              {formik.touched.description && formik.errors.description && (
                <FeildError>{formik.errors.description}</FeildError>
              )}
            </FeildWraper>

            {/* Features */}
            <FeildWraper width="100%">
              <FormLabel>Features</FormLabel>
              <textarea
                name="features"
                value={formik.values.features}
                onChange={formik.handleChange}
                rows={6}
                placeholder="Write or edit package features here..."
              />

              <FormLineBreak />
            </FeildWraper>

            {/* === T-shaped divider === */}
            {extraMeta.length > 0 && (
              <div className={Style.tDividerWrapper}>
                <div className={Style.horizontalLine} aria-hidden="true" />
                <div className={` ${Style.dividerLabel} px-2`}>Additional Fields</div>
              </div>
            )}

            {/* === Extra meta rows === */}
            {/* <div className={Style.extraMetaContainer}>
              {extraMeta.map((field, idx) => (
                <div key={idx} className={Style.extraMetaRow}>
                  <input
                    type="text"
                    placeholder="Meta key"
                    value={field.key}
                    onChange={(e) => {
                      const updated = [...extraMeta];
                      updated[idx].key = e.target.value;
                      setExtraMeta(updated);
                    }}
                    className={Style.metaInput}
                  />
                  <input
                    type="text"
                    placeholder="Meta value"
                    value={field.value}
                    onChange={(e) => {
                      const updated = [...extraMeta];
                      updated[idx].value = e.target.value;
                      setExtraMeta(updated);
                    }}
                    className={Style.metaInput}
                  />
                  <button
                    type="button"
                    onClick={() =>
                      setExtraMeta(extraMeta.filter((_, i) => i !== idx))
                    }
                    className="text-red-500 hover:text-red-700 transition-all p-1"
                    title="Delete field"
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              ))}

              <div className={Style.addBtnWrap}>
                <button
                  type="button"
                  onClick={() =>
                    setExtraMeta([...extraMeta, { key: "", value: "" }])
                  }
                  className={Style.addBtn}
                >
                  + Add Field
                </button>
              </div>
            </div> */}

            <FeildWraper width="100%">
              {extraMeta?.map((field, index) => (
                <div className={`w-full flex gap-3`} key={index}>
                  {/* key */}

                  <input
                    type="text"
                    placeholder="Meta key"
                    value={field.key}
                    onChange={(e) => {
                      const updated = [...extraMeta];
                      updated[index].key = e.target.value;
                      setExtraMeta(updated);
                    }}
                    className={Style.metaInput}
                  />

                  {/* value */}
                  <input
                    type="text"
                    placeholder="Meta value"
                    value={field.value}
                    onChange={(e) => {
                      const updated = [...extraMeta];
                      updated[index].value = e.target.value;
                      setExtraMeta(updated);
                    }}
                    className={Style.metaInput}
                  />

                  <Tooltip
                    key={`${index}-asideBottomItems`}
                    className={`${Style.Tooltip}`}
                    boxClassName={Style.TooltipBox}
                    content="Delete Field"
                    position={"bottom center"}
                  >
                    <div
                      onClick={() =>
                        setExtraMeta(extraMeta.filter((_, i) => i !== index))
                      }
                      className="p-3 text-red-600"
                    >
                      <Trash2 size={18} />
                    </div>
                  </Tooltip>
                </div>
              ))}

              <button
                type="button"
                onClick={() =>
                  setExtraMeta([...extraMeta, { key: "", value: "" }])
                }
                className="flex flex-start text-blue-700 font-medium   w-full p-2 text-[16px]"
              >
                + Add Field
              </button>
            </FeildWraper>
          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {dealData?.dealid ? "Save Changes" : "Create Deal"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditDealModal;
